var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnimeGraphExplorer',{attrs:{"targetAnimeId":_vm.animeId,"animeMapping":_vm.animeMapping}})}
var staticRenderFns = []

export { render, staticRenderFns }